/**
 * API base URL. Value comes from VUE_APP_API_BASE_URL, which vue.config.js fills from api.config.js
 * (https://db.sakhtineo.com) unless overridden in the environment. Do not hardcode API hosts elsewhere.
 */
export const API_BASE_URL = String(process.env.VUE_APP_API_BASE_URL || '').replace(/\/+$/, '') + '/'

/** Dev server proxies /api and /uploads to API_BASE_URL (avoids CORS), so requests stay same-origin there. */
export const USE_DEV_PROXY = process.env.NODE_ENV === 'development' && process.env.VUE_APP_DIRECT_API !== '1'

/** Base used for requests: '/' behind the dev proxy, otherwise the real API host. */
export const REQUEST_BASE = USE_DEV_PROXY ? '/' : API_BASE_URL

/** Absolute URL for an API path, for places that can't use the http client (window.open, <img>, 3rd-party widgets). */
export function apiUrl(path = '') {
  const p = String(path || '').replace(/^\/+/, '')
  return (USE_DEV_PROXY ? window.location.origin + '/' : API_BASE_URL) + p
}
